(() => {
  const stripInert = (slide) => {
    if (slide.hasAttribute('inert')) slide.removeAttribute('inert');
    if (slide.getAttribute('aria-hidden') === 'true') slide.removeAttribute('aria-hidden');
  };

  const handleCarousel = (carousel) => {
    if (carousel.dataset.inertFixApplied === '1') return;
    carousel.dataset.inertFixApplied = '1';

    const apply = () => {
      const slides = carousel.querySelectorAll('.carousel__slide');
      slides.forEach(stripInert);
    };

    apply();

    const observer = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && (m.attributeName === 'inert' || m.attributeName === 'aria-hidden')) {
          if (m.target.classList.contains('carousel__slide')) stripInert(m.target);
        }
        if (m.type === 'childList' && m.addedNodes.length) {
          apply();
        }
      }
    });
    observer.observe(carousel, {
      attributes: true,
      attributeFilter: ['inert', 'aria-hidden'],
      subtree: true,
      childList: true,
    });
  };

  const init = () => {
    document.querySelectorAll('.products.carousel.flickity-enabled').forEach(handleCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
})();
